<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/QWkVBd/tc-custom/9781620066171.jpg?1704717834341" alt="This image is the cover for the book Murder Run"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Murder Run
      </h1>
      <p class="bookDescription body article font2">
        <b>A wealthy woman’s death in a picturesque corner of Connecticut pulls her down-on-his-luck handyman into a sprawling criminal underworld . . .</b><br/>  <br/> Awakened in the night by a mysterious and alarming call, handyman Jed Cooper rushes to the stately home of his employer, an emotionally fragile choreographer who has secluded herself in Connecticut’s Litchfield Hills. But it’s too late. She’s dead and a shadowy figure has bolted into the darkness. Just in time for the cops to show up and find Jed standing over her body.<br/>  <br/> Jed may be innocent but he can’t help feeling some haunting stirrings of guilt—after all, she’d been acting even more skittish than usual in recent days. Thanks to his sketchy past he prefers to stay as far from trouble as he can get. But he’s already entangled in this murder case, and as the fallout mounts, this twisty tale moves from Manhattan’s Little Italy to Miami and beyond as the truth slowly comes to light . . .<br/>  <br/><b>Praise for the writing of Shelly Frome</b><br/>  <br/> “Complex and eventful . . . an intelligently conceived mystery and an entertaining one as well.” —<i>Kirkus Reviews</i><br/>  <br/> “Suspenseful . . . The plot takes numerous satisfying twists.” —<i>Publishers Weekly</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Shelly Frome
      </h2>
      
      <p class="authorDescription body article">Shelly Frome is a member of Mystery Writers of America, a professor of dramatic arts emeritus at the University of Connecticut, a former professional actor, a writer of crime novels and books on theater and film. He is also a features writer for Gannett Media. His fiction includes Sun Dance for Andy Horn, Lilac Moon, Twilight of the Drifter, Tinseltown Riff, and Murder Run. Among his works of non-fiction are The Actors Studio and texts on the art and craft of screenwriting and writing for the stage. Moon Games is his latest foray into the world of crime and the amateur sleuth. He lives in Black Mountain, North Carolina.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Sunbury Press, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?df0002e4